/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Inject, OnDestroy, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';

import { FILTER_TYPE, IAutocompleteOption } from 'app/models/filter.models';
import { isValueNotEmpty } from 'app/utils/all-data.utils';
import { NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/divider';
import { AllDataDateFilterComponent } from '../filters/date-filter/date-filter.component';
import { AllDataYearFilterComponent } from '../filters/year-filter/year-filter.component';
import { AllDataTimeFilterComponent } from '../filters/time-filter/time-filter.component';
import { AllDataSelectFilterComponent } from '../filters/select-filter/select-filter.component';
import { MultiSelectWithSearchComponent } from '../../../shared/form/multiselect-with-search/multiselect-with-search.component';
import { FormsModule } from '@angular/forms';
import { AllDataTextFilterComponent } from '../filters/text-filter/text-filter.component';

@Component({
  selector: 'app-all-data-filter-dialog',
  templateUrl: './all-data-filter-dialog.component.html',
  styleUrls: ['./all-data-filter-dialog.component.scss'],
  imports: [
    NgIf,
    MatButton,
    MatIcon,
    MatDivider,
    AllDataDateFilterComponent,
    AllDataYearFilterComponent,
    AllDataTimeFilterComponent,
    AllDataSelectFilterComponent,
    MultiSelectWithSearchComponent,
    FormsModule,
    AllDataTextFilterComponent,
  ],
})
export class AllDataFilterDialogComponent implements OnDestroy {
  @Output() apply = new EventEmitter<{ dateFrom?: Date; dateTo?: Date }>();

  onClearSubject = new Subject<void>();

  data: any;
  value: any;
  options?: any;
  isSingle?: boolean;

  header = '';
  type = FILTER_TYPE.TEXT;

  constructor(
    private dialogRef: MatDialogRef<AllDataFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {
    this.data = data.value;
    this.header = data.title;
    this.type = data.type;
    if (this.type === FILTER_TYPE.AUTOCOMPLETE) {
      data.options.subscribe((options: IAutocompleteOption[]) => (this.options = options));
    }
    if (this.type === FILTER_TYPE.SELECT) {
      this.options = data.options;
      this.isSingle = data.isSingle;
    }
  }

  get isNotEmpty() {
    return isValueNotEmpty(this.data) || isValueNotEmpty(this.value);
  }

  ngOnDestroy(): void {
    this.onClearSubject.complete();
  }

  clear = (): void => {
    this.data = undefined;
    this.value = undefined;
    this.onClearSubject.next();
  };

  cancel = (): void => {
    this.dialogRef?.close();
  };

  filterChange = (value: any): void => {
    this.value = value;
  };

  onApply = (): void => {
    this.apply.emit(this.value);
    this.dialogRef?.close();
  };
}
